import Login from '../components/g_authentication/Login';

export default {
  path: '/',
  name: 'Login',
  component: Login,
  beforeEnter: (to, from, next) => {
    next();
  }
};






// WEBPACK FOOTER //
// ./src/router/Login.router.js